import React from "react";
import "./QethjeLarje.css";
import { Link } from "react-router-dom";

import qethje from "../../Assets/qethje_icon_-1-400x400.png";
import mjekra from "../../Assets/rregullimi_i_mjekres_icon-400x400.png";
import frizure from "../../Assets/frizure_profesionale_icon-400x400.png";
import sherbime from "../../Assets/sherbime_tjera-400x400.png";

const QethjeLarje = () => {
  return (
    <div className="container-foto">
      <p id="experience">
        Experience the immediate difference of{" "}
        <span className="barber"> Barber</span>
      </p>
      <p id="enjoy">
        Explore our{" "}
        <Link to="/services">
          {" "}
          <span className="barber">Services</span>{" "}
        </Link>{" "}
      </p>

      <div className="group">
        <div className="card">
          <img src={qethje} alt="" />
          <h3>Haircut</h3>

        </div>
        <div className="card">
          <img src={mjekra} alt="" />
          <h3>Beard trimming</h3>

        </div>
        <div className="card">
          <img src={frizure} alt="" />
          <h3>Professional hairstyling</h3>

        </div>
        <div className="card">
          <img src={sherbime} alt="" />
          <h3>Hair Wash</h3>
        </div>
      </div>
    </div>
  );
};

export default QethjeLarje;
